import React from 'react';
import axios from 'axios';
import './style.css';
import {Link, withRouter} from 'react-router-dom';
import SessionStore from '../../components/Stores/SessionStore';
import {Button, FormControl, FormGroup, HelpBlock} from "react-bootstrap";

class Sign extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            values: {
                email: '',
                password: ''
            },
            validation: {
                states:{
                    sign: null,
                },
                messages: {
                    sign: ''
                }
            }
        };

        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].classList.remove('nav-md');
        document.getElementsByTagName('body')[0].classList.add('login');
    }

    componentWillUnmount() {
        document.getElementsByTagName('body')[0].classList.remove('login');
        document.getElementsByTagName('body')[0].classList.add('nav-md');
    }

    handleChangeEmail(event) {
        let email = event ? event.target.value : this.state.values.email;

        let values = this.state.values;
        values.email = email;

        let validation = this.state.validation;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (re.test(email)) {
            validation.states.sign = "success";
            validation.messages.sign = '';
        } else {
            validation.states.sign = "error";
            validation.messages.sign = 'Zkontrolujte formát e-mailu!'
        }

        this.setState({
            values,
            validation
        });
    }

    handleChangePassword(event) {
        let password =  event ? event.target.value : this.state.values.password;

        let values = this.state.values;
        values.password = password;

        let validation = this.state.validation;
        validation.states.sign = password === '' ? 'error' : null;
        validation.messages.sign = password === '' ? 'Vyplňte heslo!' : '';

        this.setState({
            values,
            validation
        });
    }

    isValid() {
        this.handleChangeEmail();
        this.handleChangePassword();

        let {validation} = this.state;

        return Object.values(validation.states).indexOf('error') < 0;
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()) {
            axios.post(this.props.api.login, {
                ...this.state.values
            }).then((res) => {
                if (res.data.user.role !== 'admin') {
                    alert('Neplatné přihlašovací údaje');
                    return false;
                }
                const sessionStore = new SessionStore();
                sessionStore.storeToken(res.data.token);
                sessionStore.storeUser(res.data.user);
                this.props.history.push('/');
            }).catch((error) => {
                console.error('Axios error: ', error);
                alert("Chybné přihlašovací údaje!");
            });
        }
    }

    render() {
        let {values, validation} = this.state;

        return (
            <div className="login-wrapper">
                <div className="animate form login-form">
                    <section className="login-content">
                        <form onSubmit={this.handleSubmit}>
                            <h1>Přihlášení</h1>
                            <FormGroup controlId="email" validationState={validation.states.sign}>
                                <FormControl type="email" onChange={this.handleChangeEmail} value={values.email} placeholder="Zadejte email"/>
                            </FormGroup>
                            <FormGroup controlId="password" validationState={validation.states.sign}>
                                <FormControl type="password" onChange={this.handleChangePassword} value={values.password} placeholder="Zadejte heslo"/>
                                <HelpBlock>{validation.messages.sign}</HelpBlock>
                            </FormGroup>
                            <div>
                                <Button type="submit" className="btn btn-default" >Přihlásit</Button>
                                <Link className="reset-pass" to="/ForgottenPassword">Zapomenuté heslo?</Link>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        );
    }
}

export default withRouter(Sign);



/** WEBPACK FOOTER **
 ** ./src/containers/Sign/index.js
 **/